export default __webpack_public_path__ + "static/media/Siddhesh.4bb11502.jpeg";